import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, StackItem } from '../../Atoms/Stack';
import { useTabLabelNumber } from './TabLabelNumber.hooks';
import { TabLabelNumberLabel, TabLabelNumberPosition, TabLabelNumberRoot, TabLabelNumberSeparator } from './TabLabelNumber.styles';
import { TabBadge } from './TabsLabels.styled';
// Component.
// -----------------------------------------------------------------------------
export const TabLabelNumber = ({ definition, mode, number, selected, selectedColor }) => {
    // Hooks.
    // ---------------------------------------------------------------------------
    const { isDisabled, label, onClick } = useTabLabelNumber({
        definition,
        number
    });
    // Render.
    // ---------------------------------------------------------------------------
    return (_jsxs(TabLabelNumberRoot, { disabled: isDisabled, selected: selected, selectedColor: selectedColor, onClick: onClick, children: [_jsx(TabLabelNumberPosition, { disabled: isDisabled, mode: mode, selected: selected, selectedColor: selectedColor, children: label }), _jsx(TabLabelNumberSeparator, { disabled: isDisabled, mode: mode, children: "/" }), _jsx(TabLabelNumberLabel, { disabled: isDisabled, mode: mode, children: _jsxs(Stack, { alignment: "center", gap: "xs", children: [_jsx(StackItem, { children: definition.label }), definition.badge && _jsx(TabBadge, { children: definition.badge })] }) })] }));
};
//# sourceMappingURL=TabLabelNumber.js.map